import { Client } from '@core/models/client.model';
import { Company } from '@core/models/company.model';
import { EmissionChecklistItem } from '@core/models/emission-checklist-item.model';
import { PermissionGroupSpecsChoice } from '@core/models/permission-group-specs-choice.model';
import { PermissionGroup } from '@core/models/permission-group.model';
import { QuestionsAndAnswersCategory } from '@core/models/questions-and-answers-category.model';
import { ValueObject } from '@core/models/value-object.model';

export class FormOption {
  public name: string = null;
  public value: string | number | boolean = null;

  constructor(name: FormOption['name'], value: FormOption['value']) {
    this.name = name;
    this.value = value;
  }

  public static fromClient = (client: Client): FormOption => {
    const personName = `${client.firstname ?? ''} ${client.surname ?? ''}`.trim();
    const name =
      client.type === 'company'
        ? client.companyName || client.id
        : personName || client.companyName || client.id;
    return new FormOption(name, client.id);
  };
  public static fromCompany = (company: Company): FormOption => ({ name: company.name, value: company.id });
  public static fromEmissionChecklistItem = (eci: EmissionChecklistItem): FormOption => ({
    name: eci.name,
    value: eci.id,
  });
  public static fromPermissionGroup = (pg: PermissionGroup): FormOption => ({ name: pg.name, value: pg.id });
  public static fromPermissionGroupSpecsChoices = (pgsc: PermissionGroupSpecsChoice): FormOption => ({
    name: pgsc.name,
    value: pgsc.value,
  });
  public static fromQuestionsAndAnswersCategory = (category: QuestionsAndAnswersCategory): FormOption => ({
    name: category.name,
    value: category.id,
  });
  public static fromValueObject = (vo: ValueObject): FormOption => ({ name: vo.name, value: vo.codename });
}
